export const MIN_WITHDRAWAL_FEE = '0';
export const MAX_WITHDRAWAL_FEE = '10';
export const MAX_CREDIT_FACILITY_DURATION = '12';
export const MAX_FLEXI_24_DURATION = '24';
export const MAX_TERM_LOAN_DURATION = '60';
export const MIN_DURATION = '1';
export const MIN_REPAYMENT_AMOUNT = '10';

// UK config
export const MIN_UK_AMOUNT = '1000';
export const MAX_UK_AMOUNT = '1000000';
export const MIN_UK_INTEREST_RATE = '1';
export const MAX_UK_CREDIT_FACILITY_INTEREST_RATE = '5.7';
export const MAX_UK_FLEXI_24_INTEREST_RATE = '5.15';
export const MAX_UK_TERM_LOAN_INTEREST_RATE = '5.15';
export const MIN_UK_CREDIT = '100';

// DE config
export const MIN_DE_AMOUNT = '1000';
export const MAX_DE_AMOUNT = '500000';
export const MIN_DE_INTEREST_RATE = '1';
export const MAX_DE_CREDIT_FACILITY_INTEREST_RATE = '2.5';
export const MAX_DE_TERM_LOAN_INTEREST_RATE = '1.66';
export const MIN_DE_CREDIT = '150';
